const Footer = () => {
  return (
    <footer>
      &copy; kramcke.com | 2023
    </footer>
  );
}

export default Footer;